module.exports = __webpack_public_path__ + "static/media/voluntier.acdc65be.png";